import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

import HorizontalRule from 'components/HorizontalRule';
import { getMarketplaceStats } from 'redux/ducks/Dashboard';
import { rateForState } from 'components/AverageRatesModal/Constants';
import './MarketplaceStatsModal.scss';

class MarketplaceStatsModal extends Component {
  state = { zipInput: '' };

  componentDidUpdate(prevProps) {
    if (!prevProps.isOpen && this.props.isOpen) {
      this.setState({ zipInput: this.props.marketplaceStats.currentZip || '' });
    }
  }

  isValidZip = (zip) => zip.length === 5 && /^\d{5}$/.test(zip);

  onZipChange = (e) => {
    this.setState({ zipInput: e.target.value });
  };

  onRefresh = () => {
    const { zipInput } = this.state;
    if (this.isValidZip(zipInput)) {
      this.props.getMarketplaceStats(zipInput);
    }
  };

  render() {
    const { isOpen, onClose, marketplaceStats, user } = this.props;
    const { zipInput } = this.state;
    const { atsWithin50Miles, loading, zipError, currentZip, currentState } = marketplaceStats;
    const rateDisplay = rateForState(currentState) || '—';

    const displayZip = currentZip || user.addressZip || '';
    const stateLabel = currentState || '(your area)';
    const zipValid = this.isValidZip(zipInput);

    return (
      <Modal isOpen={isOpen} toggle={onClose} backdrop="static" className="marketplace-stats-modal">
        <ModalHeader className="header" toggle={onClose}>Change Zip Code</ModalHeader>
        <ModalBody>
          <div className="msm-zip-control">
            <label className="msm-label" htmlFor="msm-zip-input">
              Search a different zip code
            </label>
            <div className="msm-input-row">
              <input
                id="msm-zip-input"
                type="text"
                className={`msm-input form-control${zipError ? ' is-invalid' : ''}`}
                value={zipInput}
                onChange={this.onZipChange}
                placeholder="Enter 5-digit zip"
                maxLength={5}
              />
              <button
                className={`msm-refresh-btn${zipValid ? ' msm-refresh-btn--active' : ''}`}
                onClick={this.onRefresh}
                disabled={!zipValid}
                aria-label="Refresh results"
                type="button"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                  <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/>
                </svg>
              </button>
            </div>
            {zipError && (
              <div className="invalid-feedback d-block">{zipError}</div>
            )}
          </div>

          <HorizontalRule dashed margin="16px" />

          <div className="msm-stats-col">
            <div className="msm-stat">
              <span className="msm-stat-value">
                {loading ? '—' : (atsWithin50Miles ?? '—')}
              </span>
              <span className="msm-stat-label">
                verified ATs within 50 miles of {displayZip || 'your zip'}
              </span>
            </div>
            <div className="msm-stat">
              <span className="msm-stat-value">
                {loading ? '—' : rateDisplay}
              </span>
              <span className="msm-stat-label">avg transacted rate in {stateLabel}</span>
            </div>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  marketplaceStats: state.dashboard.marketplaceStats,
  user: state.session.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
  getMarketplaceStats: (zip) => dispatch(getMarketplaceStats(zip)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MarketplaceStatsModal);
